import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    async logout(event) {
        event.preventDefault()
        const response = await fetch( this.element.href, {
            method: "DELETE",
            headers: {
                "Accept": "application/json",
                "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
            },
            credentials: "same-origin"
        })

        if (response.ok) {
            window.location.href = "/"  // or whatever path you want to redirect to
        }
    }
} 